// import GuideTemplate from "../guide-template/guideTemplate";
// import useBrowserMode from "../shared/hooks/useBrowserMode";
import React from "react";
import Layout from "../components/organisms/layout/layout";
import SEO from "../shared/seo";
import "./../styles/index.scss";
import { ReferenciaContenido } from "../interfaces/ReferenciaContenido";
import LibraryComponents from "../components/templates/library-components/libraryComponents";

const IndexPage = (props: any | undefined) => {

   const referenciaContenido:ReferenciaContenido[] = props?.pageContext.allContentfulHome.nodes[0].referenciaContenido;
   const metaTitle = props?.pageContext.allContentfulHome.nodes[0].metaTitulo;
   const metaDescription = props?.pageContext.allContentfulHome.nodes[0].metaDescripcion;
   // const [isGuideActive, setGuideActive] = useState <boolean> (false);
   // const {isBrowser, localStorage} = useBrowserMode();

   // useEffect(() => {
   //    if (isBrowser) {
   //       if (!localStorage.getItem('WasGuideActive')) {
   //          localStorage.setItem('WasGuideActive','True')
   //          setTimeout(() => {setGuideActive(true);} , 3000) 
   //       }
   //    }
   // }, []);

   return (
      <>
         {/* <GuideTemplate isActive={isGuideActive} />  */}
         <Layout hideHeaderDesktop={false} hideHeaderMobile={true}>
            <SEO 
               title={ metaTitle || "Home" } 
               description={ metaDescription && metaDescription.json.content[0].content[0].value } 
               image={ referenciaContenido && referenciaContenido[0].referenciaPlantillaContenido[0].imagenPrincipal[0].file.url }
               lang={ "es" }
            />
            {referenciaContenido.map(
               (value:ReferenciaContenido, index:number) => (
                  <section id={ 'section'+index } key={ index } >
                     <LibraryComponents
                        content={value} 
                        categoryName={'Home'}  
                     />
                  </section>
               ))
            }
         </Layout>
      </>
   );
};

export default IndexPage;
